import { Check } from "lucide-react";

/**
 * Two-column layout:
 *   Left column (5 cols on lg): eyebrow + heading + gold divider + intro paragraph
 *   Right column (7 cols): icon list of items
 * Matches the reference "Why clients engage us" / "Considerations for this sector" sections.
 */
export default function SplitList({ section }) {
  const { eyebrow, heading, paragraphs = [], list_items = [], theme = "white" } = section;
  const bgClass = theme === "navy" ? "bg-mist-navy text-white" : theme === "off" ? "bg-mist-off" : "bg-white";
  const headingColor = theme === "navy" ? "text-white" : "text-mist-navy";
  const paraColor = theme === "navy" ? "text-white/70" : "text-mist-ink/70";
  const itemColor = theme === "navy" ? "text-white/85" : "text-mist-ink/85";

  return (
    <section className={`${bgClass} py-24 lg:py-32`}>
      <div className="container-mist grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="max-w-2xl text-left">
            {heading && (
              <h2
                className={`font-display text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.1] tracking-tight ${headingColor}`}
              >
                {heading}
              </h2>
            )}
            {(eyebrow || heading) && <div className="mt-4 gold-divider" />}
          </div>
          {paragraphs[0] && (
            <p className={`mt-6 text-sm ${paraColor} leading-relaxed`}>{paragraphs[0]}</p>
          )}
        </div>
        <div className="lg:col-span-7">
          <ul className="space-y-4">
            {list_items.map((li, i) => (
              <li key={i} className={`flex gap-3 ${itemColor} text-[15px] leading-relaxed`}>
                <Check className="h-5 w-5 text-mist-gold shrink-0 mt-0.5" aria-hidden />
                <span>{li}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
